import React from 'react';
import { CategoryNameStyled } from './styles';

interface MedicalCategoryNameProps {
  categoryName: string;
}

export const MedicalCategoryName: React.FC<MedicalCategoryNameProps> = ({ categoryName }) => {
  return <CategoryNameStyled>{categoryName}</CategoryNameStyled>;
};
